// src/components/admin/common/LockReasonFields.tsx

import React from "react";
import { useTranslation } from "react-i18next";
import { ADMIN_REASON_MAX_LENGTH } from "../../../constants";
import { AdminCharCounter } from "./AdminCharCounter";
import "./LockReasonFields.css";

interface LockReasonFieldsProps {
  reason: string;
  onReasonChange: (value: string) => void;
  visible: boolean;
  onVisibleChange: (value: boolean) => void;
}

/**
 * Extra fields rendered inside <ConfirmModal> when an admin locks a topic,
 * match, club, person, or team. Lets the admin optionally write a note
 * explaining the lock, and choose whether that note is shown to regular
 * users (checked) or kept as an admin-only note (unchecked).
 *
 * Only rendered for the LOCK action — unlocking stays a plain one-click
 * toggle with no modal, per the original request.
 */
export const LockReasonFields: React.FC<LockReasonFieldsProps> = ({
  reason,
  onReasonChange,
  visible,
  onVisibleChange,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <label className="confirm-modal__reason-label">
        {t("admin_lock_reason_label")}
      </label>
      <textarea
        className="confirm-modal__reason-input"
        placeholder={t("admin_lock_reason_hint")}
        value={reason}
        onChange={(e) => onReasonChange(e.target.value)}
        maxLength={ADMIN_REASON_MAX_LENGTH}
        rows={3}
      />
      <AdminCharCounter value={reason} max={ADMIN_REASON_MAX_LENGTH} />
      <label className="lock-reason-visible-check">
        <input
          type="checkbox"
          checked={visible}
          onChange={(e) => onVisibleChange(e.target.checked)}
        />
        {t("admin_lock_reason_visible_label")}
      </label>
    </>
  );
};